import React from "react";

const FingerprintBig = ({ ...rest }) => {
    return (
        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
            <path d="M6.7747 21.6188C6.79536 21.584 6.81652 21.5493 6.83819 21.5149C8.41843 19.0028 9.33322 16.0321 9.33322 12.8333C9.33322 10.256 11.4226 8.16667 13.9999 8.16667C16.5772 8.16667 18.6666 10.256 18.6666 12.8333C18.6666 14.0199 18.5858 15.1883 18.4294 16.3333M15.9591 24.3176C16.6727 22.8931 17.2578 21.393 17.6992 19.8333M22.1779 21.1539C22.9305 18.51 23.3333 15.7187 23.3333 12.8333C23.3333 7.67868 19.1547 3.5 14 3.5C12.3 3.5 10.7061 3.95451 9.33333 4.74863M3.5 17.9248C4.24743 16.3863 4.66667 14.6588 4.66667 12.8333C4.66667 11.1333 5.12117 9.53948 5.9153 8.16667M13.9998 12.8333C13.9998 16.9367 12.8229 20.7653 10.7882 23.9997" 
                stroke="#2A2E44" 
                strokeWidth="2.33" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
            />
        </svg>
    );
};

export default FingerprintBig;
